document.addEventListener("DOMContentLoaded", () => {
  const sticky = document.querySelector(".sticky-wrapper_choose_option");
  const info = document.querySelector(".new-product-info");
  const btn = document.querySelector(".choose_option_button");
  const recharge = document.querySelector(".pdp-recharge-option__wrapper");

  if (sticky && info) {
    new IntersectionObserver(([e]) =>
      sticky.classList.toggle("sticky_active", !e.isIntersecting)
    ).observe(info);
  }

  btn && recharge && btn.addEventListener("click", e => {
    e.preventDefault();

    const offset = 120; // 👈 manual offset from top (adjust)
    const top =
      recharge.getBoundingClientRect().top +
      window.pageYOffset -
      offset;

    window.scrollTo({
      top,
      behavior: "smooth"
    });
  });
});
